// Backend API base URL. Must match backend PORT (see project root .env).
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
export default API_URL;
export { API_URL };
